/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateEstimatedLaborCostRequest } from '../../models/update-estimated-labor-cost-request';

export interface UpdateEstimatedLaborCost$Params {
  id: string;
      body: UpdateEstimatedLaborCostRequest
}

export function updateEstimatedLaborCost(http: HttpClient, rootUrl: string, params: UpdateEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, updateEstimatedLaborCost.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

updateEstimatedLaborCost.PATH = '/v0/estimatedLaborCost/{id}';
